import { Address, AddressResult, ConnectionAddressObject } from '@origin-digital/address-lookup';
import { IMeterStatusType } from '@origin-digital/sales-common';

export const fromAddressToConnectionAddress = (address: Address): ConnectionAddressObject => {
  const qasAddress: Address = {
    buildingName: address?.buildingName,
    buildingLevelNumber: address?.buildingLevelNumber,
    buildingLevelType: address?.buildingLevelType,
    buildingNumberLast: address?.buildingNumberLast,
    subBuildingNumber: address?.subBuildingNumber,
    dpid: address?.dpid,
    unit: address?.unit,
    unitType: address?.unitType,
    unitNumber: address?.unitNumber,
    streetNumber: address?.streetNumber,
    streetName: address?.streetName,
    streetNameOnly: address?.streetNameOnly,
    streetType: address?.streetType,
    streetTypeSuffix: address?.streetTypeSuffix,
    city: address?.city,
    state: address?.state,
    postcode: address?.postcode,
    customerClass: address?.customerClass,
    label: address?.label,
    elecDetails: address?.elecDetails,
    allPostalDeliveryTypesNumber: address?.allPostalDeliveryTypesNumber,
    allPostalDeliveryTypesType: address?.allPostalDeliveryTypesType,
  };

  const qasSearchResult: AddressResult = {
    addressId: address.originAddressId ?? '',
    label: address.label ?? '',
    postcode: address.postcode,
  };

  const connectionAddressObj: ConnectionAddressObject = {
    qasAddress,
    qasSearchResult,
    originAddressId: address.originAddressId,
    batchId: address.batchId,
    nmi: address.nmi,
    nmiStatus: address.nmiStatus as IMeterStatusType,
    nmiRating: Number(address.nmiRating) || 0,
    mirn: address.mirn,
    mirnStatus: address.mirnStatus as IMeterStatusType,
    mirnRating: Number(address.mirnRating) || 0,
    isExactMatchForNMI: address.isExactMatchForNMI,
    isExactMatchForMIRN: address.isExactMatchForMIRN,
    isManualAddress: false,
    elecDetails: address.elecDetails,
    addressLabel: address.addressLabel,
    isMIRNOnSupply: address.isMIRNOnSupply ?? false,
    isNMIOnSupply: address.isNMIOnSupply ?? false,
    isSmartMeter: address.isSmartMeter,
    isSolarAvailable: address.isSolarAvailable,
    isSelected: address.isSelected,
    customerClass: address.customerClass,
    feederClass: address.feederClass,
  };

  return connectionAddressObj;
};
